export const ExitWithoutSavingModal: string = 'ExitWithoutSaving';
